/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type FileType, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { RevRequestBuilderRequestsMetadata, type RevRequestBuilder } from './rev/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /registrations/export
 */
export interface ExportRequestBuilder extends BaseRequestBuilder<ExportRequestBuilder> {
    /**
     * The rev property
     */
    get rev(): RevRequestBuilder;
    /**
     * GetRegistrationsExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ExportRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * GetRegistrationsExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ExportRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetRegistrationsExport
 */
export interface ExportRequestBuilderGetQueryParameters {
    fileType?: FileType;
    registrationId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const ExportRequestBuilderUriTemplate = "{+baseurl}/registrations/export?FileType={FileType}&RegistrationId={RegistrationId}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ExportRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "fileType": "FileType",
    "registrationId": "RegistrationId",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ExportRequestBuilderNavigationMetadata: Record<Exclude<keyof ExportRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    rev: {
        requestsMetadata: RevRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ExportRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExportRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        queryParametersMapper: ExportRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
